import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { NodeData } from "../ds/client_ds.js";
import {
  AccountReceivableSearchCriteria,
  CheckBounceLinesBean,
  CheckBounceProcessBean,
  CheckBounceProcessSearchCriteria,
  CreditMemoBean,
  CustomerSearchCriteria,
  PageListBean,
  RestAccountReceivableListRequest,
  RestCheckBounceDetailsBeanRequest,
  RestCheckBounceProcessListRequest,
  RestCustomerListRequest,
  RestEntityUnLockRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../gui_components/Util.js";
import { CheckBounceLookupHandler } from "../lookup/CheckBounceLookupHandler.js";
import { CheckLookupHandler } from "../lookup/CheckLookupHandler.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  PopupARModule,
  PopupCreditMemoModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService.js";
import { CustomerService } from "../services/CustomerService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import { History, AlignStartVertical } from "lucide-react";
import CustomTable from "../gui_components/CustomTable.js";
class CheckBounce extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Check Bounce",
      companyCode: "",
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      alertMessage: [],
      alertType: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      moduleKeyCode: NEW_ENTRY,
      pageList: new PageListBean(),
      checkBounceData: new CheckBounceProcessBean(),
      criteria: new CheckBounceProcessSearchCriteria(),
      moduleOrderStatus: "",
      disabled: false,
      isResetView: true,
      error_list: [],
      nodeList: new Array(),
      selectedNodeKey: "headerView",
      isListFormOpen: false,
      isEntryFormOpen: false,
      isHistoryFormOpen: false,
      isShowNodes: true,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowModuleSearchContainer: true,
      isMaintenanceMode: true,
      isDisabledFields: false,
      loadingText: false,
      isLoading: false,
      checkBounceLookupHandler: null,
      customerLookupHandler: null,
      billToLookupHandler: null,
      checkLookupHandler: null,
      checkBounceList: [],
      creditMemoList: [],
      currencyCode: "",
      isShowBillToLookup: false,
      isShowCheckLookup: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowInvoiceModule: false,
      isShowARModule: false,
      isShowCreditMemoModule: false,
      moduleForPopup: [],
      checkPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCheckList: false,
      checkList: [],
      order: "asc",
      sortField: "",
      checkBounceLineList: [],
      statusTracks: [],
      isReseted: false,
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    this.moduleCaption = "Check Bounce";
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    ModuleUtils.getCheckBounceStatusList();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      // this.unlockCheckBounce(this.props.code);
      this.editCheckBounce(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandler();
    this.loadCache();
  }
  initLookupHandler = () => {
    let checkBounceLookupHandler = new CheckBounceLookupHandler(
      this.companyCode,
      "CheckBounce",
    );
    this.setState({
      checkBounceLookupHandler: checkBounceLookupHandler,
    });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  loadCache = () => {};
  addNewEntry = () => {
    let checkBounceData = new CheckBounceProcessBean();
    checkBounceData.companyCode = this.companyCode;
    checkBounceData.code = NEW_ENTRY;
    checkBounceData.status = "O";
    let currencyCode = "USD";
    let createdDate = new Date();
    createdDate = createdDate.toLocaleDateString("sv-SE");
    checkBounceData.checkBounceDate = createdDate;
    if (
      !isEmptyString(this.state.moduleKeyCode) ||
      this.state.moduleKeyCode != NEW_ENTRY
    )
      checkBounceData.code = this.state.moduleKeyCode;
    else checkBounceData.code = NEW_ENTRY;
    let pageTitle = this.moduleCaption + " - NEW";
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    this.setState({
      checkBounceData: checkBounceData,
      pageTitle: pageTitle,
      currencyCode: currencyCode,
      checkBounceLineList: [],
      statusTracks: [],
      selectedNodeKey: "headerView",
    });
    this.state.checkBounceData = checkBounceData;
    this.openEntryForm();
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    let checkBounceData = this.state.checkBounceData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getCheckBounceStatusCaption(
      checkBounceData.status,
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.state.moduleOrderStatus = moduleOrderStatus;
    this.setState({
      isEntryFormOpen: true,
      isListFormOpen: false,
      isHistoryFormOpen: false,
      isShowSaveButton: true,
      isShowApproveButton: false,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      disabled: false,
      isDisabledFields: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    if (checkBounceData.isFetched) {
      this.setState({
        isDisabledFields: true,
        isShowSaveButton: false,
      });
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isHistoryFormOpen: false,
      isShowSaveButton: false,
      isShowApproveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isMaintenanceMode: false,
      isDisabledFields: false,
      isResetView: false,
      isShowAutoCompleteCheckList: false,
      checkPageListForAutoCompleteList: new Array(),
      isViewMode: false,
      isSpecialViewMode: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isListFormOpen: false,
      isEntryFormOpen: false,
      isHistoryFormOpen: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let checkBounceData = this.state.checkBounceData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      headerObject,
      <AlignStartVertical size={16} />,
    );
    nodeList["headerView"] = headerNode;
    if (checkBounceData.isFetched) {
      let historyNode = new NodeData(
        "historyView",
        "History",
        historyObject,
        <History size={16} />,
      );
      nodeList["historyView"] = historyNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setHeaderView();
    } else if (selectedNode == "historyView") {
      this.setHistoryView();
    }
  };
  setHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isEntryFormOpen: true,
      isListFormOpen: false,
      isHistoryFormOpen: false,
    });
  };
  setHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isEntryFormOpen: false,
      isListFormOpen: false,
      isHistoryFormOpen: true,
    });
  };
  getHeaderView() {
    return (
      <CheckBounceEntryForm
        {...this.state}
        onChange={this.onChange}
        onCustomerCodeChange={this.onCustomerCodeChange}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        checkOnChange={this.checkOnChange}
        checkEnterKeyEventHandler={this.checkEnterKeyEventHandler}
        viewInvoiceModule={this.viewInvoiceModule}
        viewARModule={this.viewARModule}
        viewCreditMemoModule={this.viewCreditMemoModule}
        displayCheckAutoCompleteList={this.displayCheckAutoCompleteList}
        handleSortingCheckLineChange={this.handleSortingCheckLineChange}
        handleSortingCreditMemoChange={this.handleSortingCreditMemoChange}
      />
    );
  }
  getHistoryView() {
    return (
      <CheckBounceHistoryForm
        {...this.state}
        handleSortingStatusTrackChange={this.handleSortingStatusTrackChange}
      />
    );
  }
  selectButtonClick = (e) => {
    this.editCheckBounce(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editCheckBounce = (code) => {
    if (isEmptyString(code)) return;
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.CheckBounceProcessMaintainance_IsAccessible()) {
      AccountReceivableService.initCheckBounceProcessModule(
        readrestInput,
        this.editCheckBounceResponse,
        this.editCheckBounceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  editCheckBounceResponse = (response) => {
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          "Check Bounce Process Code [" +
            this.state.moduleKeyCode +
            "] Not Read Successfully"
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.checkBounceProcess != null) {
          const checkBounceData =
            response.data.mainOperationResponse.checkBounceProcess;
          let moduleKeyCode = checkBounceData.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          let checkBounceLineList = [];
          if (!isEmptyArray(checkBounceData.checkBounceLines)) {
            checkBounceLineList = checkBounceData.checkBounceLines;
          }

          this.setState({
            checkBounceData: checkBounceData,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isLoading: false,
            selectedNodeKey: "headerView",
            checkBounceLineList: checkBounceLineList,
          });
          this.state.checkBounceData = checkBounceData;
          this.isLocked = true;
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({
      isLoading: false,
    });
  };
  editCheckBounceError = (error) => {
    ShowError("error :", error);
  };
  resetView = () => {
    let checkBounceData = this.state.checkBounceData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockCheckBounce(checkBounceData.code);
    } else {
      this.isLocked = false;
    }

    checkBounceData = new CheckBounceProcessBean();
    this.setState({
      checkBounceData: checkBounceData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isDisabledFields: false,
      isShowBillToLookup: false,
      isShowCheckLookup: false,
      creditMemoList: [],
      isShowAutoCompleteCheckList: false,
      checkPageListForAutoCompleteList: new Array(),
      checkBounceLineList: [],
      statusTracks: [],
      selectedNodeKey: "headerView",
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack("", false);
    this.addNewEntry();
  };
  getModuleListView = () => {
    let checkBounceData = this.state.checkBounceData;
    if (checkBounceData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadCheckBouncePage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockCheckBounce(checkBounceData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadCheckBouncePage();
    }
  };
  filterCheckBounce = () => {
    this.loadPage(1);
  };
  resetFilterCheckBounce = () => {
    let criteria = new CheckBounceProcessSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCheckBouncePage();
  };
  loadCheckBouncePage = () => {
    let requestInput = new RestCheckBounceProcessListRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.CheckBounceProcessView_IsAccessible()) {
      AccountReceivableService.getCheckBounceProcessPageList(
        requestInput,
        this.loadCheckBounceResponse,
        this.loadCheckBounceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCheckBounceResponse = (response) => {
    if (
      response.data != null &&
      !isEmptyArray(response.data.checkBounceProcessPageList) &&
      !isEmptyArray(
        response.data.checkBounceProcessPageList.checkBounceProcesses,
      )
    ) {
      let checkBounce =
        response.data.checkBounceProcessPageList.checkBounceProcesses;
      this.state.pageList.totalCount =
        response.data.checkBounceProcessPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.checkBounceProcessPageList.currentPage;
      this.setState({
        isLoading: false,
        checkBounceList: checkBounce,
      });
    }
  };
  loadCheckBounceError = (error) => {
    ShowError("Error : ", error);
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  validateData = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.checkNumber)) {
        let errMsg = "CheckNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.customerCode)) {
        let errMsg = "CustomerCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.customerName)) {
        let errMsg = "CustomerNamme Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(data.checkBounceLines)) {
        let errMsg = "No CheckBounce Lines";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  save = () => {
    this.saveCheckBounce();
  };
  saveCheckBounce = () => {
    let checkBounceData = this.state.checkBounceData;
    let isValid = false;
    isValid = this.validateData(checkBounceData);
    if (isValid) {
      if (checkBounceData.isFetched == true) {
        if (SecurityAccessManager.CheckBounceProcessUpdate_IsAccessible()) {
          AccountReceivableService.updateCheckBounceProcess(
            checkBounceData,
            this.saveOrUpdateResponse,
            this.saveOrUpdateError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (checkBounceData.isFetched != true) {
        if (SecurityAccessManager.CheckBounceProcessCreation_IsAccessible()) {
          AccountReceivableService.createCheckBounceProcess(
            checkBounceData,
            this.saveOrUpdateResponse,
            this.saveOrUpdateError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveOrUpdateResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.checkBounceProcess != null) {
      const checkBounceData = response.data.checkBounceProcess;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        checkBounceData: checkBounceData,
        pageTitle: pageTitle,
      });
      // this.unlockCheckBounce(checkBounceData.code);
      // this.editCheckBounce(checkBounceData.code);
      if (!this.isLocked) {
        this.editCheckBounce(checkBounceData.code);
      } else {
        this.code = checkBounceData.code;
        this.unlockCheckBounce(checkBounceData.code);
      }
      this.setState({
        isLoading: false,
        checkBounceData: checkBounceData,
      });
    }
  };
  saveOrUpdateError = (error) => {
    ShowError("Error : ", error);
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  clearError = () => {};
  onChange = (e) => {
    let checkBounceData = this.state.checkBounceData;
    checkBounceData[e.target.name] = e.target.value;
    this.setState({
      checkBounceData: checkBounceData,
    });
  };
  listOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  unlockCheckBounce = (code) => {
    let requestInput = new RestEntityUnLockRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.entityCode = code;
    if (SecurityAccessManager.CheckBounceProcessMaintainance_IsAccessible()) {
      AccountReceivableService.unLockCheckBounceProcessCode(
        requestInput,
        this.unLockResponse,
        this.unlockError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unLockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editCheckBounce(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockError = (error) => {
    ShowError("Error : ", error);
  };
  customerCleared = () => {
    let checkBounceData = this.state.checkBounceData;
    checkBounceData.customerCode = "";
    checkBounceData.billToCode = "";
    checkBounceData.checkNumber = "";
    checkBounceData.customerName = "";

    this.setState({
      checkBounceData: checkBounceData,
      creditMemoList: [],
      isShowBillToLookup: false,
      isShowCheckLookup: false,
      currencyCode: "USD",
    });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.checkBounceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.checkBounceData;
      tempData.customerCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteCustomerList: showAutoCompleteList,
        checkBounceData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ heckBounceData: tempData });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.readItemByCustomerCodeError,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readItemByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  readCustomerByCustomerCodeResponse = (response) => {
    let customerData = response.data.customer;
    let checkBounceData = this.state.checkBounceData;
    if (customerData != null) {
      checkBounceData.customerCode = customerData.code;
      checkBounceData.customerName = customerData.description;
      if (customerData.billTos != null && customerData.billTos.length >= 0) {
        let billToLookupHandler = new GenericAttributeLookupHandler(
          customerData.billTos,
          "Bill To",
        );
        let billTo = customerData.billTos[0];
        if (!isEmptyString(billTo.code)) {
          checkBounceData.billToCode = billTo.code;
        } else {
          checkBounceData.billToCode = "B1001";
        }
        let checkLookupHandler = new CheckLookupHandler(
          this.companyCode,
          "Check",
          customerData.code,
        );
        this.setState({
          checkBounceData: checkBounceData,
          isShowBillToLookup: true,
          billToLookupHandler: billToLookupHandler,
          isShowCheckLookup: true,
          checkLookupHandler: checkLookupHandler,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        this.getCheckList(checkBounceData.customerCode);
      }
    }
  };
  readCustomerByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "read Customer",
    });
    if (SecurityAccessManager.CheckBounceProcessMaintainance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerByCustomerCodeResponse,
        this.readCustomerByCustomerCodeError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  checkOnChange = (e) => {
    let checkNumber = e.target.value;
    this.state.isShowAutoCompleteCheckList = true;
    let tempData = this.state.checkBounceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCheckList;
    if (isEmpty(checkNumber)) {
      this.state.isShowAutoCompleteCheckList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCheckList;
      let tempData = this.state.checkBounceData;
      tempData.checkNumber = "";
      tempData.issuedBankName = "";
      tempData.checkDate = "";
      tempData.checkAmount = 0;

      tempData.comments = "";
      tempData.checkBounceLines = [];
      let suggestion = [];
      this.setState({
        isShowAutoCompleteCheckList: showAutoCompleteList,
        checkBounceData: tempData,
        checkPageListForAutoCompleteList: suggestion,
        creditMemoList: [],
        checkBounceLineList: [],
      });
    } else if (
      e.target.name == "checkNumber" &&
      showAutoCompleteList === true &&
      checkNumber !== ""
    ) {
      this.readCheckBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ checkBounceData: tempData });
  };
  checkEnterKeyEventHandler = (e) => {
    let checkBounceData = this.state.checkBounceData;
    let code = e.target.value;

    checkBounceData["checkNumber"] = e.target.value;
    let checkList = this.state.checkList;
    let checkCodeBean = null;
    checkList.map((ck) => {
      if (ck.checkNumber == e.target.value) {
        checkCodeBean = ck;
      }
    });
    if (!isEmpty(checkCodeBean)) {
      let checkBounceData = this.state.checkBounceData;
      checkBounceData.checkNumber = checkCodeBean.checkNumber;
      this.setState({
        checkBounceData: checkBounceData,
        checkPageListForAutoCompleteList: new Array(),
      });
      this.getcheckBounceLines(checkCodeBean.checkNumber);
    }
  };
  readCheckBySearchString(searchString) {
    let checkList = this.state.checkList;
    let simpleAutoCompleteList = new Array();
    if (checkList.length > 0 && checkList != null) {
      checkList.map((ck) => {
        let simpleItemBean = {
          code: ck.checkNumber,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLists) =>
        simpleAutoCompleteLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ checkPageListForAutoCompleteList: filteredSuggestions });
  }
  displayCheckAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCheckList: isShowAutoCompleteList,
    });
  };
  getCheckList = (customerCode) => {
    let searchCriteria = new AccountReceivableSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCode = customerCode;
    let check_pageList = new PageListBean();
    check_pageList.pageSize = 150;
    let requestInput = new RestAccountReceivableListRequest();
    requestInput.pageInput = check_pageList;
    requestInput.searchCriteria = searchCriteria;
    AccountReceivableService.getAccountReceivablePageList(
      requestInput,
      this.readByCheckCodeResponse,
      this.readByCheckCodeError,
    );
  };
  readByCheckCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.accountReceivablePageList != null &&
      !isEmptyArray(response.data.accountReceivablePageList.accountReceivables)
    ) {
      let checkList =
        response.data.accountReceivablePageList.accountReceivables;
      let filterCheckList = [];
      checkList.map((ln) => {
        if (
          ln.accountReceivableStatus == "P" ||
          ln.accountReceivableStatus == "F"
        ) {
          if (
            ln.checkAmount != null &&
            ln.checkAmount != 0 &&
            ln.checkAmount > 0
          ) {
            filterCheckList.push(ln);
          }
        }
      });
      this.setState({ checkList: filterCheckList });
    }
  };
  readByCheckCodeError = (error) => {
    ShowError("Error : " + error);
  };

  checkBounceDetailsResponse = (response) => {
    if (response.data != null && response.data.detailsBean != null) {
      let checkBounceLinesList = [];
      let creditMemoList = [];
      let arNumber = "";
      let invoiceNumber = "";
      let isTooManyAR = false;
      let tempCheckBounceList = [];
      let checkBounceData = this.state.checkBounceData;
      if (response.data.detailsBean.checkDetailBean != null) {
        let checkDetail = response.data.detailsBean.checkDetailBean;
        checkBounceData.issuedBankName = checkDetail.issuedBankName;
        checkBounceData.checkDate = checkDetail.checkDate;
        checkBounceData.checkAmount = checkDetail.checkAmount;
        let currencyCode = checkDetail.currencyCode;
        checkBounceData.comments = checkDetail.comments;
        this.setState({
          currencyCode: currencyCode,
        });
      }
      if (response.data.detailsBean.accountReceivableBean != null) {
        let arData = response.data.detailsBean.accountReceivableBean;
        arNumber = arData.accountReceivableNumber;
        invoiceNumber = arData.invoiceNumber;
        if (response.data.detailsBean.receivableLines != null) {
          let arlines = response.data.detailsBean.receivableLines;
          arlines.map((ar) => {
            let i = 1;
            let check = new CheckBounceLinesBean();
            check.companyCode = ar.companyCode;
            check.lineNumber = i;
            if (!isEmptyString(ar.accountReceivableNumber)) {
              check.arCode = ar.accountReceivableNumber;
            } else {
              check.arCode = arData.code;
            }
            check.arDate = arData.accountReceivableDate;
            check.invoiceNumber = ar.invoiceNumber;
            check.invoiceAmount = ar.appliedAmount;
            check.invoiceDate = ar.invoiceDate;
            check.checkBounceProcessCode = checkBounceData.code;
            check.customerCode = checkBounceData.customerCode;
            check.checkNumber = checkBounceData.checkNumber;
            i++;
            checkBounceLinesList.push(check);
            if (
              arNumber != ar.accountReceivableNumber &&
              invoiceNumber != ar.invoiceNumber
            ) {
              isTooManyAR = true;
            }
          });
        }
        if (response.data.detailsBean.creditMemos != null) {
          let creditMemo = response.data.detailsBean.creditMemos;
          let cm = new CreditMemoBean();
          cm.code = creditMemo.code;
          cm.companyCode = creditMemo.companyCode;
          cm.creditMemoDate = creditMemo.creditMemoDate;
          cm.appliedAmount = creditMemo.appliedAmount;
          cm.totalCreditAmount = creditMemo.totalCreditAmount;
          creditMemoList.push(cm);
        }
        checkBounceData.checkBounceLines = checkBounceLinesList;
        tempCheckBounceList = checkBounceLinesList;
      }
      this.setState({
        checkBounceData: checkBounceData,
        creditMemoList: creditMemoList,
        checkBounceLineList: tempCheckBounceList,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  checkBounceDetailsError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  getcheckBounceLines = (code) => {
    let checkBounceData = this.state.checkBounceData;
    let readrestInput = new RestCheckBounceDetailsBeanRequest();
    readrestInput.customerCode = checkBounceData.customerCode;
    readrestInput.checkNumber = code;
    readrestInput.billToCode = checkBounceData.billToCode;
    readrestInput.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Fetching CheckBounce Lines",
    });
    if (SecurityAccessManager.CheckBounceProcessMaintainance_IsAccessible()) {
      AccountReceivableService.readCheckBounceDetails(
        readrestInput,
        this.checkBounceDetailsResponse,
        this.checkBounceDetailsError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  viewInvoiceModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewARModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewCreditMemoModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCreditMemoModule: true,
        moduleForPopup: (
          <PopupCreditMemoModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCreditMemoModule: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let checkBounceList = this.state.checkBounceList;
    if (sortField && !isEmptyArray(checkBounceList)) {
      const sorted = [...checkBounceList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ checkBounceList: sorted });
    }
  };
  moduleExit = () => {
    let checkBounceData = this.state.checkBounceData;
    if (checkBounceData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockCheckBounce(checkBounceData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };

  handleSortingCheckLineChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingCheckLine(sortField, sortOrder);
  };
  handleSortingCheckLine = (sortField, sortOrder) => {
    let list = this.state.checkBounceLineList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ checkBounceLineList: sorted });
    }
  };

  handleSortingStatusTrackChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStatusTrack(sortField, sortOrder);
  };
  handleSortingStatusTrack = (sortField, sortOrder) => {
    let list = this.state.statusTracks;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTracks: sorted });
    }
  };

  handleSortingCreditMemoChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingCreditMemo(sortField, sortOrder);
  };
  handleSortingCreditMemo = (sortField, sortOrder) => {
    let list = this.state.creditMemoList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ creditMemoList: sorted });
    }
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editCheckBounce}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.checkBounceLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
          isSpecialViewMode={this.state.isSpecialViewMode}
        />
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          !this.state.isHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          !this.state.isHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          !this.state.isEntryFormOpen &&
          this.state.isHistoryFormOpen &&
          this.getHistoryView()}
        {this.state.isListFormOpen && (
          <CheckBounceListForm
            {...this.state}
            editCheckBounce={this.editCheckBounce}
            filterCheckBounce={this.filterCheckBounce}
            resetFilterCheckBounce={this.resetFilterCheckBounce}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            listOnChange={this.listOnChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class CheckBounceListForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.listOnChange(e);
  };
  editCheckBounce = (e, code) => {
    if (e.detail === 1) this.props.editCheckBounce(code);
  };
  filterCheckBounce = (e) => {
    if (e.detail === 1) this.props.filterCheckBounce();
  };
  resetFilterCheckBounce = (e) => {
    if (e.detail === 1) this.props.resetFilterCheckBounce();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterCheckBounce();
    }
  };

  checkBounceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckBounce#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.editCheckBounce, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setStatusDetails(true, this.getCaption),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CheckAmount", "checkAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Created Date", "createdDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  getCaption = (status) => {
    return ModuleUtils.getCheckBounceStatusCaption(status);
  };
  render() {
    let checkBounceList = this.props.checkBounceList;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="checkBounceProcessNumberStartsWith"
                type="text"
                value={criteria.checkBounceProcessNumberStartsWith}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <Button onClick={(e) => this.filterCheckBounce(e)}>Filter</Button>
            <span className="px-2"></span>
            <Button onClick={(e) => this.resetFilterCheckBounce(e)}>
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            data={checkBounceList}
            columns={this.checkBounceColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      </div>
    );
  }
}
class CheckBounceEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCustomerCodeChange = (e) => {
    this.props.onCustomerCodeChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCustomerCompleteList = (list) => {
    this.props.displayAutoCustomerCompleteList(list);
  };
  checkOnChange = (e) => {
    this.props.checkOnChange(e);
  };
  checkEnterKeyEventHandler = (e) => {
    this.props.checkEnterKeyEventHandler(e);
  };
  viewInvoiceModule = (e, code) => {
    if (e.detail === 1) this.props.viewInvoiceModule(code);
  };
  viewARModule = (e, code) => {
    if (e.detail === 1) this.props.viewARModule(code);
  };
  viewCreditMemoModule = (e, code) => {
    if (e.detail === 1) this.props.viewCreditMemoModule(code);
  };

  handleSortingCheckLineChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingCheckLineChange(accessor);
  };
  handleSortingCreditMemoChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingCreditMemoChange(accessor);
  };
  render() {
    let checkBounceData = this.props.checkBounceData;
    let checkBounceLineList = this.props.checkBounceLineList;
    let checkBounceLines = [];
    checkBounceLines = checkBounceData.checkBounceLines;
    let creditMemoList = this.props.creditMemoList;
    let currencyCode = this.props.currencyCode;
    const textAreaStyle = {
      height: "8em",
      width: "20em",
      resize: "none",
      padding: "3px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <div className="div_inline">
          <div className="div_75_no_overflow_no_height header_div">
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>CheckBounce Date</FormLabel>
              </Col>
              <Col sm="3">
                <DatePickerComponent
                  onChange={this.onChange}
                  name="checkBounceDate"
                  value={checkBounceData.checkBounceDate}
                  disabled={true}
                ></DatePickerComponent>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Customer</FormLabel>
              </Col>
              <Col className="align-items-left" sm="3">
                <InputTextbox
                  ref={this.customerRef}
                  name="customerCode"
                  placeholder="Enter Customer"
                  onChange={this.onCustomerCodeChange}
                  value={checkBounceData.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.props.customerLookupHandler}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCustomerCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCustomerList
                  }
                  disabled={this.props.isDisabledFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="4">
                <InputTextbox
                  onChange={this.onChange}
                  name="customerName"
                  value={checkBounceData.customerName}
                  disabled={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bill To</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  name="billToCode"
                  value={checkBounceData.billToCode}
                  lookupRequired={this.props.isShowBillToLookup}
                  lookupHandler={this.props.billToLookupHandler}
                  disabled={this.props.isDisabledFields}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left">
                <FormLabel>Check Details</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Check</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.checkOnChange}
                  name="checkNumber"
                  value={checkBounceData.checkNumber}
                  lookupRequired={this.props.isShowCheckLookup}
                  lookupHandler={this.props.checkLookupHandler}
                  disabled={this.props.isDisabledFields}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.checkEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.checkPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.props.displayCheckAutoCompleteList
                  }
                  showAutoCompleteList={this.props.isShowAutoCompleteCheckList}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Check Date</FormLabel>
              </Col>
              <Col sm="3">
                <DatePickerComponent
                  onChange={this.onChange}
                  name="checkDate"
                  value={checkBounceData.checkDate}
                  disabled={true}
                ></DatePickerComponent>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>CheckAmount</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <NumberFormatInputbox
                  onChange={this.onChange}
                  name={"checkAmount"}
                  className="summary_input text-right"
                  value={checkBounceData.checkAmount}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Bank Name</FormLabel>
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  name="issuedBankName"
                  value={checkBounceData.issuedBankName}
                  disabled={true}
                ></InputTextbox>
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Currency</FormLabel>{" "}
              </Col>
              <Col sm="3">
                <InputTextbox
                  onChange={this.onChange}
                  name="currencyCode"
                  value={currencyCode}
                  disabled={true}
                />
              </Col>
            </Row>
          </div>
          <div className="div_25_no_overflow_no_height">
            <Row>
              <Col>
                <FormLabel className="label_head">Comments</FormLabel>
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left">
                <textarea
                  style={textAreaStyle}
                  name="comments"
                  type="text"
                  onChange={this.onChange}
                  value={checkBounceData.comments}
                  disabled={this.props.isDisabledFields}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="div_inline">
          <div className="div_60_no_overflow">
            <div className="div_Custom_3">
              <Row>
                <Col className="align-items-left">
                  <FormLabel className="label_head">
                    Check Bouncelines
                  </FormLabel>
                </Col>
              </Row>
              <table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingCheckLineChange(e, "arCode")
                      }
                    >
                      AR
                      {this.props.order === "desc" &&
                      this.props.sortField === "arCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCheckLineChange(e, "arDate")
                      }
                    >
                      AR Date
                      {this.props.order === "desc" &&
                      this.props.sortField === "arDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCheckLineChange(e, "invoiceNumber")
                      }
                    >
                      Invoice#
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCheckLineChange(e, "invoiceAmount")
                      }
                    >
                      InvoiceAmount
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCheckLineChange(e, "invoiceDate")
                      }
                    >
                      Invoice Date
                      {this.props.order === "desc" &&
                      this.props.sortField === "invoiceDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {checkBounceLineList != null && (
                  <tbody>
                    {checkBounceLineList.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          {" "}
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) => this.viewARModule(e, ln.arCode)}
                          >
                            {ln.arCode}
                          </Button>
                        </td>
                        <td>{ln.arDate}</td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewInvoiceModule(e, ln.invoiceNumber)
                            }
                          >
                            {ln.invoiceNumber}
                          </Button>
                        </td>
                        <td className="text-right">{ln.invoiceAmount}</td>
                        <td>{ln.invoiceDate}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <div className="div_40_no_overflow">
            <div className="div_Custom_3">
              <Row>
                <Col className="align-items-left">
                  <FormLabel className="label_head">Credit Memo</FormLabel>
                </Col>
              </Row>
              <table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th
                      onClick={(e) =>
                        this.handleSortingCreditMemoChange(e, "code")
                      }
                    >
                      Credit Memo#
                      {this.props.order === "desc" &&
                      this.props.sortField === "code" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCreditMemoChange(
                          e,
                          "totalCreditAmount",
                        )
                      }
                    >
                      Total CreditAmount
                      {this.props.order === "desc" &&
                      this.props.sortField === "totalCreditAmount" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingCreditMemoChange(e, "creditMemoDate")
                      }
                    >
                      CreatedDate
                      {this.props.order === "desc" &&
                      this.props.sortField === "creditMemoDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </tr>
                </thead>
                {creditMemoList != null && (
                  <tbody>
                    {creditMemoList.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCreditMemoModule(e, ln.code)
                            }
                          >
                            {ln.code}
                          </Button>
                        </td>
                        <td className="text-right">{ln.totalCreditAmount}</td>
                        <td>{ln.creditMemoDate}</td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class CheckBounceHistoryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }
  handleSortingStatusTrackChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingStatusTrackChange(accessor);
  };

  render() {
    let checkBounceData = this.props.checkBounceData;
    let statusTracks = this.props.statusTracks;
    if (!statusTracks) {
      let statusTracks = new Array();
    }
    return (
      <div className="header_div">
        <div className="div_inline">
          {" "}
          <div class="div_Equal">
            <FormLabel>Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "createdDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "currentStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "previousStatus")
                  }
                >
                  Previous Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "createdBy")
                  }
                >
                  Done By
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusTrackChange(e, "remarks")
                  }
                >
                  Remarks
                  {this.props.order === "desc" &&
                  this.props.sortField === "remarks" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </thead>
              {statusTracks != null && (
                <tbody>
                  {statusTracks.map((list, index) => (
                    <tr key={index}>
                      <td>{list.createdDate}</td>
                      <td>{list.currentStatus}</td>
                      <td>{list.previousStatus}</td>
                      <td>{list.createdBy}</td>
                      <td>{list.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
function CheckBounceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <CheckBounce {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default CheckBounceModule;
